import { Fab, useTheme } from '@mui/material';
import { AppTooltip } from 'src/components';
import { IconAlert } from 'src/libraries/icons';

interface Props {
  title: string;
  bg?: string;
  size?: number;
}

const CustomTooltip: React.FC<Props> = ({ title, bg, size = 20 }) => {
  const theme = useTheme();

  if (!title) {
    return null;
  }

  return (
    <AppTooltip placement="top" title={title} enterTouchDelay={0}>
      <Fab
        size="small"
        sx={{
          minHeight: size,
          height: size,
          width: size,
          backgroundColor: bg || theme?.palette.branded.carbon,
          '&:hover': { backgroundColor: bg || theme?.palette.branded.carbon },
          mb: 0.3,
          mx: 0.5,
        }}
      >
        <IconAlert />
      </Fab>
    </AppTooltip>
  );
};

export default CustomTooltip;
